import * as React from 'react';

const PRODUCT_TYPES = {
  CURSO: 'Curso',
  TRILHA: 'Trilha',
};

// eslint-disable-next-line
export const useProductForm = (productProps, isUpdate) => {
  const { tipoProduto, idPortfolio, nome } = productProps ?? {};

  const [formData, setFormData] = React.useState({
    nome: isUpdate ? nome : '',
    idPortfolio: isUpdate ? idPortfolio : '',
    idDisponibilizacao: '',
    codigoProdutoSas: '',
    codigoDisponibilizacaoSas: '',
    tipoProduto: isUpdate ? tipoProduto : null,
    descricao: '',
    objetivo: '',
    cargaHoraria: '',
    tempoRealizacao: '',
    valor: '',
    listaModulo: [],
    ativo: true,
    publico: {},
    funcionalidades: {},
    isLoginWhatsapp: false,
    linkWhatsapp: '',
    linkTelegran: '',
    isLoginTelegran: false,
    url: '',
    tags: [],
    tagInput: '',
    temasSelecionadas: {},
  });

  const updateField = React.useCallback((field, value, mask = null) => {
    setFormData((prev) => ({
      ...prev,
      [field]: mask ? mask(value) : value,
    }));
  }, []);

  const updateMultipleFields = React.useCallback((updates) => {
    setFormData((prev) => ({ ...prev, ...updates }));
  }, []);

  const toggleCheckbox = React.useCallback((id, field) => {
    setFormData((prev) => {
      const current = { ...prev[field] };
      if (id in current) {
        delete current[id];
      } else {
        current[id] = id;
      }
      return { ...prev, [field]: current };
    });
  }, []);

  const addTag = React.useCallback(() => {
    setFormData((prev) => {
      if (!prev.tagInput.trim()) return prev;
      return {
        ...prev,
        tags: [...prev.tags, prev.tagInput.trim()],
        tagInput: '',
      };
    });
  }, []);

  const deleteTag = React.useCallback((tagToDelete) => {
    setFormData((prev) => ({
      ...prev,
      tags: prev.tags.filter((tag) => tag !== tagToDelete),
    }));
  }, []);

  const addModule = React.useCallback(
    (module) => {
      if (!module || formData.listaModulo.includes(module)) return;
      setFormData((prev) => ({
        ...prev,
        listaModulo: [...prev.listaModulo, module],
      }));
    },
    [formData.listaModulo],
  );

  const removeModule = React.useCallback((index) => {
    setFormData((prev) => ({
      ...prev,
      listaModulo: prev.listaModulo.filter((_, i) => i !== index),
    }));
  }, []);

  const isCompleteForm = React.useMemo(
    () =>
      formData.tipoProduto?.label === PRODUCT_TYPES.CURSO ||
      formData.tipoProduto?.label === PRODUCT_TYPES.TRILHA,
    [formData.tipoProduto],
  );

  return {
    formData,
    setFormData,
    updateField,
    updateMultipleFields,
    toggleCheckbox,
    addTag,
    deleteTag,
    addModule,
    removeModule,
    isCompleteForm,
  };
};
